import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from '@/app/AppShell';
import { LazyFallback, StubPage } from '@/app/RouteExtras';
import { LandingPage } from '@/modules/landing/LandingPage';

const WordleRoot = lazy(() => import('@/modules/wordle/WordleRoot'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <LandingPage /> },
      {
        path: 'wordle',
        element: (
          <Suspense fallback={<LazyFallback />}>
            <WordleRoot />
          </Suspense>
        ),
      },
      { path: 'privacy', element: <StubPage messageKey="privacyStub" /> },
      { path: 'terms', element: <StubPage messageKey="termsStub" /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
